import {
  Component,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { RouterLinkWithHref } from '@angular/router';
// import { ModalContainerSwipeComponent } from '../../../../../../../lk/transport/screens/rent/shared/modals/modal-container-swipe/modal-container-swipe.component';
import { TitleComponent } from '../../../content-desktop/components/title/title.component';
import {RegionalityService} from '../../../../../../common/services/regionality.service';
import {ToolsService} from '../../../../../../common/services/tools.service';
import {DialogService} from 'primeng/dynamicdialog';
import {FeedbackComponent} from '../../../../../../common/components/feedback/feedback.component';

@Component({
  selector: 'ra-mobile-space',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    RouterLinkWithHref,
    // ModalContainerSwipeComponent,
    TitleComponent,
  ],
  templateUrl: './mobile-space.component.html',
  styleUrls: ['./mobile-space.component.scss'],
  providers: [DialogService],
})
export class MobileSpaceComponent implements OnInit, OnDestroy {
  @Output() closeSelf = new EventEmitter();
  alive = true;
  showAdditional = {
    estate: false,
    transport: false,
    commercial: false,
    etc: false,
  };
  showModal = {
    support: false,
    create: false,
    profile: false,
    idea: false,
    favorites: false,
    offers: false,
  };
 @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth) {
      if (event.target.innerWidth > 750) {
        this.closeSelf.emit();
      }
    }
  }

  constructor(
    public _regionSettings: RegionalityService,
    private _tools: ToolsService,
    // private _modals: AccountModalsService,
    private _dialog: DialogService
  ) {
 }

  ngOnInit(): void {
    this._tools.scrollToTopImmediately();
    this._tools.banBodyScroll();
  }


  openModal(
    state: 'support' | 'create' | 'profile' | 'idea' | 'favorites' | 'offers',
  ) {
    switch (state) {
      case 'profile': {
        this.showModal = {
          profile: true,
          create: false,
          support: false,
          idea: false,
          favorites: false,
          offers: false,
        };
        return;
      }
      case 'create': {
        this.showModal = {
          profile: false,
          create: true,
          support: false,
          idea: false,
          favorites: false,
          offers: false,
        };
        return;
      }
      case 'support': {
        this.showModal = {
          profile: false,
          create: false,
          support: true,
          idea: false,
          favorites: false,
          offers: false,
        };
        return;
      }
      case 'idea': {
        this.showModal = {
          profile: false,
          create: false,
          support: false,
          idea: true,
          favorites: false,
          offers: false,
        };
        return;
      }
      case 'favorites': {
        this.showModal = {
          profile: false,
          create: false,
          support: false,
          idea: false,
          favorites: true,
          offers: false,
        };
        return;
      }
      case 'offers': {
        this.showModal = {
          profile: false,
          create: false,
          support: false,
          idea: false,
          favorites: false,
          offers: true,
        };
        return;
      }
    }
  }


  close() {
    this.showModal = {
      create: false,
      support: false,
      profile: false,
      idea: false,
      offers: false,
      favorites: false,
    };
  }

  openFeedbackModal(id: number) {
   this._dialog.open(FeedbackComponent, {
     header: 'Форма обратной связи',
     data: id
   });
    // switch (id) {
    //   case 6: {
    //     this._modals.openModal({
    //       type: 'feedback',
    //       data: {
    //         subjectId: 6,
    //       },
    //     });
    //     this.closeSelf.emit();
    //     return;
    //   }
    //   case 9: {
    //     this._modals.openModal({
    //       type: 'feedback',
    //       data: {
    //         subjectId: 9,
    //       },
    //     });
    //     this.closeSelf.emit();
    //     return;
    //   }
    //   default: {
    //     this._modals.openModal({
    //       type: 'feedback',
    //     });
    //     this.closeSelf.emit();
    //   }
    // }
  }

  openCityModal() {
    // this._modals.openModal({ type: 'city' });
    // this.closeSelf.emit();
  }


  ngOnDestroy(): void {
    this.alive = false;
    this._tools.allowBodyScroll();
  }
}
